export type Modality = "individual" | "group" | "no_coach"

export enum CohortModalities {
    Individual = "individual",
    Group = "group",
    NoCoach = "no_coach"
}

export enum SelfAssessmentType {
    Diagnostic = "diagnostic",
    ReflectionObjective = "reflection_objective"
}

export enum AttendanceStatuses {
    PRESENT = "present",
    NOT_PRESENT = "not_present"
}

export type InvitationStatus = "accepted" | "tentative" | "declined" | "pending" | "unknown"
export type AttendanceStatus = "present" | "not_present" | null
export type LikertColorType = "blank" | "gray" | "colored" | "brand" | "blank-2"

export interface ColorRange {
    from_option: number
    to_option: number
    uuid: string
    color: string
}
